const getFormatByMimetypes = (mimetype: string): string => {
  switch (mimetype) {
    case 'image/jpeg':
      return 'jpg';
    case 'image/jpg':
      return 'jpg';
    case 'image/png':
      return 'png';
    case 'application/pdf':
      return 'pdf';
    case 'application/octet-stream':
      return 'pdf';
    case 'video/mp4':
      return 'mp4';
    case 'video/quicktime':
      return 'mov';
    case 'video/mov':
      return 'mov';
    case 'video/webm':
      return 'webm';
    default:
      return '';
  }
};

export default getFormatByMimetypes;
